module.exports = __webpack_public_path__ + "assets/img/download.66f2bcf4.svg";